import { render, staticRenderFns } from "./facturasPendientes.vue?vue&type=template&id=b45a5076&scoped=true&"
import script from "./facturasPendientes.vue?vue&type=script&lang=js&"
export * from "./facturasPendientes.vue?vue&type=script&lang=js&"
import style0 from "./facturasPendientes.vue?vue&type=style&index=0&id=b45a5076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45a5076",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/ALIO/APP/APPVentas/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileActionText } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VContainer,VExpansionPanel,VExpansionPanelContent,VFlex,VIcon,VList,VListTile,VListTileActionText,VListTileContent,VListTileSubTitle,VListTileTitle,VTextField,VTooltip})
